var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigWarningExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.312,
    height: 69.543,
    viewBox: "0 0 3.312 69.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .exclamationA {\n                fill: #ffb831;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "exclamationA",
    d: "M40.4,29.757a1.652,1.652,0,0,0-1.656,1.656V77.775a1.656,1.656,0,0,0,3.312,0V31.413A1.652,1.652,0,0,0,40.4,29.757Zm0,62.92a1.652,1.652,0,0,0-1.656,1.656v3.312a1.656,1.656,0,0,0,3.312,0V94.333A1.652,1.652,0,0,0,40.4,92.677Z",
    transform: "translate(-38.742 -29.757)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWarningExclamation);
export default __webpack_public_path__ + "static/media/big-warning-exclamation.2fe0560e.svg";
export { ForwardRef as ReactComponent };